/**
 * Created by hejikun on 2017/10/30 0030.
 */
import axios from './modules/axios'
import config from './config'
// import _ from 'lodash'
import $ from 'jquery'
import wx from 'weixin-js-sdk'
import velocity from 'static/js/velocity.min'
import IScroll from 'static/js/iscroll'
import Swiper from 'static/js/swiper'
let toolArr = [
  // 类库注册
  ['axiosBaseApi', axios.axiosBaseApi],
  ['newDytApiBaseApi', axios.newDytApiBaseApi],
  ['maskBaseApi', axios.maskBaseApi],
  // ['_', _],
  ['$', $],
  ['wx', wx],
  ['velocity', velocity],
  ['IScroll', IScroll],
  ['Swiper', Swiper],
  ['$isMy', config.isMy],
  ['$isH5', config.isH5],
  // 项目环境变量设置
  ['$imgBaseSrc', config.imgBaseSrc],
  ['$isTest', config.isTest],
  ['$canTest',config.canTest],
  ['$from', config.from],
  ['$wechat_id', config.wechatId],
  ['$user_id', config.userId],
  ['$userDetail', config.userDetail],
  ['$is_wx', config.isWx],
  ['$noNeedLead', config.noNeedLead],
  ['$token', config.token],
  ['$allowAdv', config.allowAdv],
  ['$allowThirdSite', config.allowThirdSite],
  ['$allowOnlineAsk', config.allowOnlineAsk],
  ['$newAttention', config.newAttention],
  ['$useNewPay', config.useNewPay],
  ['$allowUserWrite', config.allowUserWrite],
  ['$isTx', config.isTx],
  ['$openMinappPay', config.openMinappPay],
  ['$mini_openid', config.mini_openid],
  ['$alipay_user_id', config.alipay_user_id]
]

let toolMap = new Map(toolArr)
const requireModules = require.context('./modules', true, /\.js$/)

wx.miniProgram.getEnv((res) => {
  if (res.miniprogram) {
    // 在小程序
    localStorage.setItem('is_wx', 1)
  } else {
    // 在公众号
    localStorage.setItem('is_wx', 0)
  }
})
requireModules.keys().forEach((fileName) => {
  const componentConfig = requireModules(fileName)
  const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')
  toolMap.set(componentName, componentConfig.default || componentConfig)
})

export default {
  install: function (_Vue) {
    toolMap.forEach((tool, key) => {
      _Vue.prototype[key] = tool
      window[key] = tool
    })
  }
}
